import { styled } from '@elliemae/ds-system';
import { DSComboBoxName, DSComboboxSlots } from '../../theming.js';

export const StyleHiddenInput = styled('input')<{ isDisabled: boolean }>`
  color: transparent;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  &:focus {
    outline: none;
  }
  ${({ isDisabled }) => isDisabled && `cursor: not-allowed;`}
`;

export const StyledInput = styled('input', {
  name: DSComboBoxName,
  slot: DSComboboxSlots.INPUT,
})<{ withoutCaret: boolean; applyAriaDisabled: boolean }>`
  line-height: 1rem;
  background: transparent;
  font-size: 1rem;
  border: none;
  overflow: hidden;
  padding: 0;
  z-index: 2;
  outline: none;
  color: ${(props) => props.theme.colors.neutral[700]};
  &:focus {
    outline: none;
  }
  ${({ withoutCaret }) => withoutCaret && 'caret-color: transparent;'}
  &::placeholder {
    color: transparent;
  }
  transition: none;
  ${({ applyAriaDisabled }) => applyAriaDisabled && `cursor: not-allowed; caret-color: transparent;`}
`;

export const StyledInputPlaceHolder = styled.div`
  font-style: italic;
  color: ${(props) => props.theme.colors.neutral[500]};
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  user-select: none;

  line-height: 1rem;
  font-size: 1rem;

  & span::after {
    content: '';
    padding: 1px;
    // solve italic font style clipping issue with overflow hidden.
  }
`;

export const StyledInputWidthReference = styled.span`
  visibility: hidden;
  position: absolute;
  top: -9999px;
  z-index: 1;
`;

export const StyledInputWrapper = styled('div')`
  position: relative;
  align-items: center;
  display: flex;
  padding-right: 1px;
  overflow: hidden;
`;

export const StyledHiddenDiv = styled('div')`
  display: none;
`;
